document.addEventListener("DOMContentLoaded", function () {

    function formatDate(date, withYear = false) {
        return date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            ...(withYear && { year: "numeric" })
        });
    }

    const today = new Date();

    const orderDate = new Date(today);

    const processingDate = new Date(today);
    processingDate.setDate(today.getDate() + 1);

    const transitDate = new Date(today);
    transitDate.setDate(today.getDate() + 2);

    const outDate = new Date(today);
    outDate.setDate(today.getDate() + 3);

    const deliveredDate = new Date(today);
    deliveredDate.setDate(today.getDate() + 4);

    document.querySelector(".order-date").textContent = formatDate(orderDate);
    document.querySelector(".processing-date").textContent = formatDate(processingDate);
    document.querySelector(".transit-date").textContent = formatDate(transitDate);
    document.querySelector(".out-date").textContent = formatDate(outDate);
    document.querySelector(".delivered-date").textContent = formatDate(deliveredDate, true);

    // Active progress (0-4)
    let currentStep = 3;

    const steps = document.querySelectorAll(".tracker-step");
    const lines = document.querySelectorAll(".line");

    steps.forEach((step, index) => {
        if (index <= currentStep) {
            step.classList.add("active");
        }
    });

    lines.forEach((line, index) => {
        if (index < currentStep) {
            line.classList.add("active");
        }
    });

});